import { render, staticRenderFns } from "./receiptDetail.vue?vue&type=template&id=0528bce2"
import script from "./receiptDetail.vue?vue&type=script&lang=js"
export * from "./receiptDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports